// Constants used throughout the app

export const MOBILE_BREAKPOINT = 1231;